import { useTranslation } from 'react-i18next';
import { Alert } from '@seeqdev/qomponents';
import type { StyleXStyles } from '@stylexjs/stylex';

interface FormWarningProps {
  warningText: string;
  xstyle?: StyleXStyles;
  extraClassNames?: string;
  testId?: string;
}

interface FormWarningNodeProps {
  warningContent: React.ReactNode;
  xstyle?: StyleXStyles;
  extraClassNames?: string;
  testId?: string;
}

export const FormWarning = (props: FormWarningProps) => {
  const { warningText, extraClassNames, testId } = props;
  const { t } = useTranslation();

  return (
    <Alert
      xstyle={props.xstyle}
      dismissible={false}
      extraClassNames={extraClassNames}
      variant="warning"
      testId={testId}>
      {t(warningText)}
    </Alert>
  );
};

export const FormWarningNode = (props: FormWarningNodeProps) => {
  const { warningContent, extraClassNames, testId } = props;
  return (
    <Alert
      xstyle={props.xstyle}
      dismissible={false}
      extraClassNames={extraClassNames}
      variant="warning"
      testId={testId}>
      {warningContent}
    </Alert>
  );
};
